import { render, staticRenderFns } from "./Comments.vue?vue&type=template&id=1acd9c1c&scoped=true"
import script from "./Comments.vue?vue&type=script&lang=js"
export * from "./Comments.vue?vue&type=script&lang=js"
import style0 from "./Comments.vue?vue&type=style&index=0&id=1acd9c1c&lang=scss&scoped=true"
import style1 from "./Comments.vue?vue&type=style&index=1&id=1acd9c1c&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1acd9c1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1acd9c1c')) {
      api.createRecord('1acd9c1c', component.options)
    } else {
      api.reload('1acd9c1c', component.options)
    }
    module.hot.accept("./Comments.vue?vue&type=template&id=1acd9c1c&scoped=true", function () {
      api.rerender('1acd9c1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Sector/Post/Card/Comments.vue"
export default component.exports